(function($) {
	function getItemLabel()
	{
		switch(document.documentElement.lang) {
			case 'fr':
				return 'Champ requis';
			case 'de':
				return 'Pflichtfeld';
			case 'es':
				return 'Campo requerido';
			case 'it':
				return 'Campo obbligatorio';
			default:
				return 'Required field';
		}
	}

	const itemMarkup = `<div class="form-required-legend small text-xs mt-2" style="flex-grow: 1; display: block; grid-column: 1 /-1;">* ${ getItemLabel() }</div>`;

	Drupal.behaviors.formRequiredMention = {
		attach: function(_context) {
			const $forms = $('form:not([id^="views-exposed-form"])'); // on ne traite pas les formulaires exposés
			$forms.each(function() { // on parse le formulaire à chaque attach au cas où celui-ci évolue
				const $inputs = $(this).find('input:not([type=submit]):not([type=image]):not([type=hidden]),textarea[required],select');
				const $formRequiredLegend = $(this).find('.form-required-legend');
				let nbRequired = 0;
				let nbOptionnal = 0;
				$inputs.each(function() {
					if ($(this).is('[required]'))
						nbRequired++;
					else
						nbOptionnal++;
				})

				const needRequiredMention = nbRequired && nbOptionnal;
				if (needRequiredMention && !$formRequiredLegend.length)
				{
					$(this).append(itemMarkup)
				}
				else if (!needRequiredMention && $formRequiredLegend.length)
				{
					$formRequiredLegend.remove();
				}
			});

		}
	};

})(jQuery);